// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1-id5","inner":"Footer_inner__2f09l"};